import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const DOCS = {
  terms: {
    title: "Terms & Conditions",
    testid: "legal-modal-terms",
  },
  privacy: {
    title: "Privacy Policy",
    testid: "legal-modal-privacy",
  },
};

export default function LegalModal({ doc, onClose }) {
  useEffect(() => {
    if (!doc) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [doc, onClose]);

  const meta = doc ? DOCS[doc] : null;

  return (
    <AnimatePresence>
      {meta && (
        <motion.div
          key="legal-modal"
          data-testid="legal-modal"
          className="fixed inset-0 z-[110] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          role="dialog"
          aria-modal="true"
          aria-label={meta.title}
        >
          <div
            data-testid="legal-modal-backdrop"
            onClick={onClose}
            className="absolute inset-0 bg-[#04070F]/85 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.97 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-lg rounded-2xl border border-white/10 bg-navy-900 p-7 shadow-2xl sm:p-9"
          >
            <button
              data-testid="legal-modal-close"
              onClick={onClose}
              aria-label="Close"
              className="absolute right-5 top-5 grid h-9 w-9 place-items-center rounded-full border border-white/15 text-white transition-colors hover:border-emerald-400/60 hover:text-emerald-300"
            >
              <X className="h-4 w-4" />
            </button>
            <h3
              data-testid={meta.testid}
              className="font-display text-xl font-bold text-white sm:text-2xl"
            >
              {meta.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              The complete document will be published here. For any questions,
              reach out from your CDM Pay account after login.
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
